export const Override = {
  textTabColor: "#222",
  focusedTextTabColor: "#fff",
  completedStep: "#569D59",
};
